"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-dark-section">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/modern_office_bright_professional.png)]" style={{
      transform: "translateZ(0)"
    }} />
      <div className="absolute inset-0 bg-white/70" />

      {}
      <div ref={contentRef} className="relative z-10 container mx-auto px-6 text-center max-w-4xl">
        <div className={`transition-all duration-700 ease-[var(--ease-smooth)] ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="text-[56px] md:text-[72px] leading-[1.1] font-bold tracking-[-0.3px] text-foreground mb-6">
            The Cloud
          </h1>
          <p className="text-[20px] md:text-[24px] leading-[1.5] text-muted-foreground mb-8 max-w-2xl mx-auto">
            Cloud solutions are the future for bookkeeping
          </p>
          <Link to="#cloud-solutions">
            <Button size="lg" className="text-[18px] px-8 py-6 h-auto rounded-[var(--radius-full)] shadow-medium hover:shadow-strong">
              Explore Solutions
            </Button>
          </Link>
        </div>
      </div>

      {}
      <Link to="#introduction" className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-2 text-muted-foreground hover:text-foreground transition-colors duration-[var(--duration-medium)]">
          <span className="text-sm font-medium">Scroll Down</span>
          <svg className="w-6 h-6 animate-bounce" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
        </div>
      </Link>
    </section>;
}